<template>
  <view-wrapper
    prefix="Add new"
    name="Users"
    path="users"
    :showCancel="true"
    addedText="Add users"
    :addedFunc="postUser"
    :validation="validation"
    :hasChangesBeenMade="hasChangesBeenMade"
    :loading="loading"
  >
    <p class="text-highlight" v-show="showWarning" >{{warningText}}</p>
    <wrapper class="mb-5" :focus="users.length > 0">
      <grafokett-input
        @keyup.enter.native="addUsers"
        v-model="email"
        type="email"
        labelPlaceholder="Users emails"
      />
      <filter-and-sort-box
        v-if="users.length > 0"
        class="pt-5"
        :data="users"
        :headers="headers"
      >
        <template v-slot:d="{ d }">
          <div class="email-box p-3 pb-2 rounded light">
            {{ d.email }}
            <grafokett-button
              class="secondary float-right small"
              @click="removeEmail(d.email)"
              >Remove</grafokett-button
            >
          </div>
        </template>
      </filter-and-sort-box>
    </wrapper>

    <wrapper class="mb-5">
      <p v-if="availableRoles.length > 0">Roles</p>
      <div
        class="pt-1 flex"
        v-for="(role, i) in availableRoles"
        :key="'role' + i"
      >
        <checkbox
          class="m-1"
          :value="roles.includes(role.id)"
          @input="addRemoveRole(i, role.id)"
        />
        <div
          class="cursor-pointer select-none"
          @click="addRemoveRole(i, role.id)"
        >
          <span class="block pl-5">{{ role.name }}</span>
          <span class="block pl-5 text-xs">{{ role.description }}</span>
        </div>
      </div>

      <p v-if="availablePermissions.length > 0" class="mt-5">Permissions</p>
      <div
        class="pt-2 flex"
        v-for="(permission, i) in availablePermissions"
        :key="'permission' + i"
      >
        <checkbox
          class="m-1"
          :value="permissions.includes(permission.userPermission)"
          @input="addRemovePermission(i, permission.userPermission)"
        />
        <div
          class="cursor-pointer select-none"
          @click="addRemovePermission(i, permission.userPermission)"
        >
          <span class="block pl-5">{{ permission.userPermission }}</span>
          <span class="block pl-5 text-xs">{{ permission.description }}</span>
        </div>
      </div>
    </wrapper>

    <assign-groups class="mb-5" :groups="availableGroups" v-model="groups" />
  </view-wrapper>
</template>

<script>
import GrafokettInput from "../components/forms/Input.vue";
import AssignGroups from "../components/datacomponents/AssignGroups";
import Wrapper from "../components/Wrapper";
import Checkbox from "../components/forms/Checkbox";
import FilterAndSortBox from "../components/FilterAndSortBox";
import GrafokettButton from "../components/forms/Button";

export default {
  components: {
    GrafokettInput,
    AssignGroups,
    Wrapper,
    Checkbox,
    FilterAndSortBox,
    GrafokettButton
  },
  data() {
    return {
      email: "",
      emails: [],
      users: [],
      showPopUp: false,
      modalAdded: false,
      groups: [],
      roles: [],
      permissions: [],
      headers: {
        email: "Email adress"
      },
      maxUsers: 50,
      currentUsers: 0,
      warningText: "",
      showWarning: false,
      loading: false
    };
  },
  methods: {
    hasChangesBeenMade() {
      return (
        this.users.length > 0 ||
        this.groups.length > 0 ||
        this.roles.length > 0 ||
        this.permissions.length > 0
      );
    },
    handleCommas(emailString) {
      if (emailString.indexOf(",") > 0) {
        let emails = emailString.split(",");
        emails.map(e => {
          this.handleSemicolon(e);
          this.handleSpace(e);
          e.length > 3 ? this.emails.push(e) : "";
        });
      }
    },
    handleSemicolon(emailstring) {
      if (emailstring.indexOf(";") > 0) {
        let emails = emailstring.split(";");
        emails.map(e => {
          this.handleCommas(e);
          this.handleSpace(e);
          e.length > 3 ? this.emails.push(e) : "";
        });
      }
    },
    handleSpace(emailstring) {
      if (emailstring.indexOf(" ") > 0) {
        let emails = emailstring.split(" ");
        emails.map(e => {
          this.handleSemicolon(e);
          this.handleCommas(e);
          e.length > 3 ? this.emails.push(e) : "";
        });
      }
    },
    splitEmails() {
      if (this.email.includes(",")) {
        this.handleCommas(this.email);
        this.email = "";
      }
      if (this.email.includes(";")) {
        this.handleSemicolon(this.email);
        this.email = "";
      }
      if (this.email.includes(" ")) {
        this.handleSpace(this.email);
        this.email = "";
      }
      if (this.email) {
        this.emails.push(this.email);
        this.email = "";
      }
      this.email = "";
    },
    addUsers() {
      this.splitEmails();
      if (this.emails.length > 0) {
        this.emails.map(e => this.addUser(e));
      }
      this.emails = [];
      this.email = "";
    },
    addUser(email) {
      const invitationSlots = this.maxUsers - this.currentUsers;
      if (this.users.length > invitationSlots) {
        this.showWarning = true;
        this.warningText = `Maximum amount of users (${this.maxUsers}) for your organization reached! There are only ${invitationSlots + this.users.length} available invitation slots.`
      } else if (!this.users.map(e => e.email).includes(email)) {
        this.users.push({email: email});
        this.showWarning = false;
      }
    },
    removeEmail(email) {
      this.users = this.users.filter(u => u.email !== email);
      this.showWarning = false;
    },
    addRemoveRole(index, id) {
      const i = this.roles.indexOf(id);
      if (i === -1) this.roles.push(id);
      else this.roles.splice(i, 1);
    },
    addRemovePermission(index, userPermission) {
      const i = this.permissions.indexOf(userPermission);
      if (i === -1) this.permissions.push(userPermission);
      else this.permissions.splice(i, 1);
    },
    async getData() {
      this.loading = true;
      await this.$store.dispatch("GROUPS/GET_AVAILABLE_GROUPS");
      await this.$store.dispatch("ROLES/GET");
      await this.$store.dispatch("PERMISSIONS/GET");
      const responseUsersCount = await this.$store.$api.get('/api/users/count');
      const settingsResponse = await this.$store.$api.get('/api/subscription');
      this.maxUsers = settingsResponse.data.data.maxUsers;
      this.currentUsers = responseUsersCount.data.data.usersCount;
      this.loading = false;
    },
    async postUser() {
      if (this.email !== "") {
        this.addUser();
      }
      this.loading = true;
      const payload = {
        invitations: [],
        groups: this.groups.map(e => e.id)
      };
      payload.invitations.push({
        users: this.users.map(e => e.email),
        roles: this.roles,
        permissions: this.permissions
      });
      try {
        await this.$store.dispatch("USERS/ADD", payload);
        this.loading = false;
        this.modalAdded = true;
      } catch (error) {
        console.error(error);
        this.loading = false;
      }
    },
    validation() {
      return (
        this.users.length > 0 && this.roles.length > 0 && this.groups.length > 0 && this.users.length <= this.maxUsers - this.currentUsers
      );
    }
  },
  computed: {
    availablePermissions() {
      return this.$store.getters["PERMISSIONS/PERMISSIONS"];
    },
    availableRoles() {
      return this.$store.getters["ROLES/ROLES"];
    },
    availableGroups() {
      return this.$store.getters["GROUPS/GROUPS"];
    }
  },
  mounted() {
    this.getData();
  }
};
</script>
<style lang="postcss">
.email-box {
  background: #255a80;
  @apply px-2 py-4 my-1;
}
.text-highlight {
  color: #f59100;
}
</style>
